import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { Trip } from '../types';
import { useAuthStore } from '../stores/auth.store';
import { tripMembers } from '../utils/tripMembers';

export interface SplitMember { id: string; label: string }

/**
 * Everyone who can carry a share of an expense — owner included, since they are
 * a TripParticipant row like anyone else (ADR-0003) and come back first.
 */
export function useSplitMembers(trip: Trip): SplitMember[] {
  const { t } = useTranslation();
  const { user } = useAuthStore();
  return useMemo(
    () => tripMembers(trip).map(p => ({
      id: p.userId,
      label: p.userId === user?.id ? t('expenses.form.you') : (p.user.displayName || p.user.username),
    })),
    [trip, user?.id, t],
  );
}
